import {Injectable} from '@angular/core';
import {TaskModel} from '../views/models/task.model';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {RequestHeaderModel} from '../views/models/request-header.model';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  task_change$ = new BehaviorSubject<TaskModel[]>([]);
  number_task_change$ = new BehaviorSubject<number>(0);
  task_change_filtered$ = new BehaviorSubject<TaskModel[]>([]);

  constructor(private httpClient: HttpClient) {
  }

  getTasks() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/task_by_user_id').subscribe((datas: TaskModel[]) => {
      this.task_change$.next(datas);
      let count = 0;
      datas.forEach(x => {
        if (x.status == 'New') {
          count += 1;
        }
      });
      this.number_task_change$.next(count);
    });
  }
}
